export default __webpack_public_path__ + "static/media/Buy_Icon.00d49316.svg";